import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Button } from '@fabric-app/ui/components/Button';
import { Kbd } from '@fabric-app/ui/components/Kbd';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';
import TagItem from './TagItem.js';
import { IconNewTag, IconEnter } from '@fabric-app/icons/old';

const ListContainer = styled.div.withConfig({
  displayName: "TagsList__ListContainer",
  componentId: "sc-5409a9db-0"
})([
  `border:1px solid `,
  `;border-radius:4px;width:100%;box-shadow:0px 4px 25px 0px #0000000d,0px 4px 4px 0px #00000005;overflow:hidden;`
], cssVar["color-border-primary"]);
const Bold = styled.strong.withConfig({
  displayName: "TagsList__Bold",
  componentId: "sc-5409a9db-1"
})([
  `font-weight:700;`
]);
const StatusText = styled.div.withConfig({
  displayName: "TagsList__StatusText",
  componentId: "sc-5409a9db-2"
})([
  `font-size:15px;color:`,
  `;padding:8px 15px;`
], cssVar["color-text-secondary"]);
const TagsList = ({ tags, isLoading, searchQuery, onSelect }) => {
  const isSearchExactAsAnyTag = tags?.some((tag) => tag.name === searchQuery?.toLowerCase());
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      !isLoading && !isSearchExactAsAnyTag && searchQuery && /* @__PURE__ */ jsxs(Button, {
        variant: "icon",
        type: "submit",
        size: "lg",
        style: {
          width: "100%"
        },
        children: [
          /* @__PURE__ */ jsx(IconNewTag, {
            style: {
              width: "20px",
              height: "22px"
            }
          }),
          /* @__PURE__ */ jsxs("span", {
            children: [
              "Create tag ",
              /* @__PURE__ */ jsxs(Bold, {
                children: [
                  "“",
                  searchQuery,
                  "”"
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx(Kbd, {
            style: {
              marginLeft: "auto"
            },
            children: /* @__PURE__ */ jsx(IconEnter, {})
          })
        ]
      }),
      Boolean(tags?.length) && /* @__PURE__ */ jsx(ListContainer, {
        children: tags.map((tag) => /* @__PURE__ */ jsx(TagItem, {
          tag,
          onSelect
        }, tag.id))
      }),
      isLoading && Boolean(!tags?.length) && /* @__PURE__ */ jsx(StatusText, {
        children: "Loading..."
      }),
      !isLoading && !tags?.length && !searchQuery && /* @__PURE__ */ jsx(StatusText, {
        children: "No tags found"
      })
    ]
  });
};

export { TagsList as default };
//# sourceMappingURL=TagsList.js.map
